import React, {useState} from "react";
import SlideCard from "./section/slideCard";
import { withFormsy } from "formsy-react";
import { useQuery } from "@apollo/client";
import { getProductsQuery, getProductsResult } from "./logic/products";

// const plansCatalog = [
//   {
//     id: 1,
//     price: 95,
//     description: "100/20Mbps",
//   },
//   {
//     id: 2,
//     price: 125,
//     description: "250/25Mbps",
//   },
//   {
//     id: 3,
//     price: 145,
//     description: "1000/50Mbps",
//   },
// ];

export default withFormsy(function PlanSlider(props) {
  const productQuery = useQuery(getProductsQuery, {
    variables: {
      // buildingCode,
      // voucherCode: voucherCode,
      // showHidden: true,
    },
  });

  if (productQuery.loading) {
    return (<React.Fragment/>);
  }

  const products = [...getProductsResult(productQuery)]
    .sort((pq) => -pq.value)
    .slice(0, 3)
    .reverse();
  const {setValue, value} = props;
  return (
    <>
      <div className="slider">
        <div className="slider-title">
          <p className="title">{value?.id ? "Your chosen plan is" : "Choose Your Plan"}</p>
        </div>

        <div
          className="sliderShow"
        >
          {products.map((product) => (
            <SlideCard
              key={product.id}
              handleSelectPlan={setValue}
              selected={value?.id === product.id}
              value={product}
              id={product.id}
              price={product.value}
              description={product.description}
            />
          ))}
        </div>
      </div>
    </>
  );
});
